let _ = t => t,
  _t,
  _t2;
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H1 } from 'UIComponents/elements/headings';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import styled from 'styled-components';
import { NavItemEnum } from '../../constants/routing/NavItems';
import ProductIcon from '../common/ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductPageHeader = styled.header.withConfig({
  displayName: "ProductPageTitle__ProductPageHeader",
  componentId: "sc-1tuldfv-0"
})(["display:flex;flex-direction:column;width:100%;align-items:center;", ""], breakpoint.tabletPortrait(_t || (_t = _`
      padding: 0 3%;
    `)));
const StyledTitle = styled(H1).withConfig({
  displayName: "ProductPageTitle__StyledTitle",
  componentId: "sc-1tuldfv-1"
})(["color:#33475b;font-size:2rem;text-align:center;display:flex;align-items:center;min-height:44px;margin-bottom:8px;", ";"], breakpoint.cs(_t2 || (_t2 = _`
    margin-top: 0;
    justify-content: center;
  `)));
const Trademark = styled.span.withConfig({
  displayName: "ProductPageTitle__Trademark",
  componentId: "sc-1tuldfv-2"
})(["font-weight:200;font-size:70%;"]);
const ProductPageTitle = ({
  productLine,
  nonProductIdentifier
}) => {
  if (nonProductIdentifier === NavItemEnum.COMMERCE) {
    productLine = COMMERCE;
  }
  const tradeMarkMap = {
    [MARKETING]: {
      includeRegisteredTrademark: true
    },
    [SALES]: {
      includeRegisteredTrademark: true
    },
    [SERVICE]: {
      includeRegisteredTrademark: true
    },
    [CMS]: {
      includeTrademark: true
    },
    [OPERATIONS]: {
      includeRegisteredTrademark: true
    },
    [COMMERCE]: {
      includeTrademark: true
    }
  };
  const translationKeyMap = {
    [MARKETING]: 'pricingPage.pages.products.tabs.marketing.pageTitle',
    [SALES]: 'pricingPage.pages.products.tabs.sales.pageTitle',
    [SERVICE]: 'pricingPage.pages.products.tabs.service.pageTitle',
    [CMS]: 'pricingPage.pages.products.tabs.cms.pageTitle',
    [OPERATIONS]: 'pricingPage.pages.products.tabs.operations.pageTitle',
    [COMMERCE]: 'pricingPage.pages.products.tabs.commerce.pageTitle',
    [NavItemEnum.BUNDLE]: 'pricingPage.pages.products.tabs.bundle.pageTitle',
    [NavItemEnum.FREE]: 'pricingPage.pages.products.tabs.crm.pageTitle',
    [NavItemEnum.SUITE]: 'pricingPage.pages.products.tabs.suite.pageTitle',
    [NavItemEnum.MARKETING_PLUS]: 'pricingPage.pages.products.tabs.marketing-plus.pageTitle'
  };
  return /*#__PURE__*/_jsxs(StyledTitle, {
    "aria-level": 1,
    children: [productLine && /*#__PURE__*/_jsx(ProductIcon, {
      productLine: productLine,
      className: "display-inline m-right-3"
    }), productLine && translationKeyMap[productLine] && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[productLine]
    }), nonProductIdentifier && translationKeyMap[nonProductIdentifier] && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[nonProductIdentifier]
    }), productLine && tradeMarkMap[productLine].includeTrademark && /*#__PURE__*/_jsx(Trademark, {
      children: "\u2122"
    }), productLine && tradeMarkMap[productLine].includeRegisteredTrademark && /*#__PURE__*/_jsx(Trademark, {
      children: "\xAE"
    })]
  });
};
export default ProductPageTitle;